/**
 * Единственная точка чтения `import.meta.env`.
 *
 * Дальше по коду переменные окружения не читаются: так видно весь контракт
 * конфигурации в одном файле, и его легко подменить в тестах.
 */
/**
 * Демо-режим: приложение работает без Telegram и без бэкенда.
 *
 * Нужен для вёрстки на dev-площадке, где ни того, ни другого нет. Гейт
 * `import.meta.env.DEV` жёсткий и снять его переменной нельзя: в прод-сборке
 * `DEV` подставляется как `false` на этапе компиляции, и ветка демо-ответов
 * выпадает из бандла целиком. Это не «настройка по умолчанию выключена»,
 * а физическая невозможность включить.
 */
const isDemo = import.meta.env.DEV && import.meta.env.VITE_FE_DEMO === 'true';

/**
 * Число из переменной окружения или `null`.
 *
 * Пустая строка — это ОТСУТСТВИЕ значения, а не ноль: без проверки
 * `Number('')` даёт 0, и счётчик Метрики инициализировался бы номером 0,
 * молча отправляя события в никуда.
 */
function numberOrNull(raw: string | undefined): number | null {
  if (raw === undefined || raw.trim() === '') return null;
  const value = Number(raw);
  return Number.isInteger(value) && value > 0 ? value : null;
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  demo: isDemo,
  /**
   * Номер счётчика Яндекс Метрики. Не секрет: он и так виден в коде
   * страницы у любого сайта со счётчиком. Пусто — аналитика молчит,
   * а приложение работает полностью.
   */
  metrikaCounterId: numberOrNull(import.meta.env.VITE_YANDEX_METRIKA_ID),
  /**
   * Заглушка Telegram для запуска в обычном браузере. Только в dev.
   *
   * В демо-режиме строка не нужна настоящая: подпись всё равно никто
   * не проверяет — запросы до бэкенда не доходят.
   */
  tgMockInitData: import.meta.env.DEV
    ? (import.meta.env.VITE_TG_MOCK_INIT_DATA ?? (isDemo ? 'demo' : null))
    : null,
} as const;
